<template>
  <main>
    <div class="container-fluid p-0 mt-0">
      <section id="carousel" v-if="showCarousel && listaCarrosel && listaCarrosel.length">
        <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :loop="true" :transition="1000">
          <slide v-for="(slide, index) of listaCarrosel" :key="index">
            <img @click="clickBanner(slide)" :src="slide.banner" style="width: 100%; object-fit: cover;"
              :class="{ 'cursor-pointer': slide.href || slide.url }" />
          </slide>
        </carousel>
      </section>
    </div>

    <div class="container-fluid mt-3" style="width: 100%; max-width: 1200px">
      <div class="row mb-3 g-3 mt-5">
        <div class="col">
          <div class="row mt-3">
            <span class="col text-left">
              <h5><strong>Categorias</strong></h5>
            </span>
          </div>
          <div class="a-divider a-divider-break"></div>
        </div>
      </div>
      <div class="justify-content-center" v-if="this.categorias">
        <carousel :per-page="1" :perPageCustom="[
          [300, 3],
          [500, 5],
          [800, 6],
          [1200, 8],
        ]" :mouse-drag="true" :autoplay="false" :loop="true" :speed="500">
          <slide v-for="(item, index) of this.categorias" :key="index">
            <div>
              <div class="col text-center">
                <a :href="'#/servico/clube-desconto?categoria=' + item.value">
                  <img class="rounded-circle circle-categoria" :src="item.url" />
                </a>
                <br />
                <span style="font-size: 18px">{{ item.nome }}</span>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
      <div class="row mb-3 g-3 mt-3">
        <div class="col-12">
          <div class="container">
            <div class="row">
              <div id="page-offer" class="col-lg-12">
                <div class="row border-bottom-gray mb-5 pb-5">
                  <div class="col-md-12">
                    <div class="text-center">
                      <img :src="clubeDesconto.thumbnail_image_url" class="img-fluid rounded"
                        style="max-height: 250px; max-width: 250px" />
                    </div>
                    <div class="pb-3">
                      <h3 class="offer-title primary-color text-center">
                        {{ clubeDesconto.title }}
                      </h3>
                      <div class="pt-2 border-bottom"></div>
                    </div>
                    <div class="px-md-5">
                      <div style="padding-bottom: 38px">
                        <b>
                          <h4 class="primary-color">Benefício</h4>
                          <span class="offer-discount" style="font-size: 15.5px">{{ clubeDesconto.discount }}</span>
                        </b>
                      </div>
                      <div class="offer-about plataform-target" style="padding-bottom: 38px">
                        <b>
                          <h4 class="primary-color">Sobre o parceiro</h4>
                        </b>
                        <div v-html="clubeDesconto.sobreParceiro"></div>
                        <br />
                        <br />
                        <b>
                          <h4 class="primary-color">Mecânica de resgate</h4>
                        </b>
                        <div v-html="clubeDesconto.mecanicaResgate"></div>
                      </div>
                      <div class="offer-legal plataform-target" style="padding-bottom: 38px">
                        <b>
                          <h4 class="primary-color">
                            Condições do benefício
                          </h4>
                        </b>
                        <div v-html="clubeDesconto.condicoesBeneficio"></div>
                      </div>
                      <div class="row"></div>
                      <div class="row"></div>
                      <div class="clearfix offer-buttons">
                        <div class="float-left">
                          <div class="pt-3">
                            <button id="button-game-modal" data-toogle="modal" data-target="modal-game"
                              class="btn primary-background-color btn-offer-main" @click="
                                openBeneficio(clubeDesconto.urlEncaminhamento)
                              ">
                              EU QUERO!
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="clearfix offer-bottom mt-3">
                        <div class="float-left">
                          <button
                            class="btn btn-gray btn_selecionar"
                            style="
                              font-size: 0.9rem;
                              color: rgb(33, 37, 41) !important;
                            "
                            data-bs-toggle="modal"
                            data-bs-target="#modalProblema"
                          >
                            Problema com o benefício?
                          </button>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
                <div id="offer-related-offers" class="mt-3">
                  <div class="head-bar">
                    <h6>
                      Ver mais ofertas
                      <!---->
                    </h6>
                    <hr align="left" class="primary-background-color" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row m-3" v-if="erro">
        <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
          {{ erro }}
        </div>
      </div>
      <div class="products">
        <div class="caixa_produtos">
          <div class="lista_produtos">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-2" v-for="item of descontos" :key="item.id">
                <div class="item_produto item_semestral text-center mt-4" data-toggle="tooltip" data-placement="top"
                  :title="item.excerpt">
                  <div class="titulo_categoria ellipsis">
                    <div :style="{
                      'background-image': urlImage(item.thumbnail_image_url),
                    }"></div>
                    <span class="justify-content-center">{{
                      item.discount
                    }}</span>
                    <span v-if="item.linkAuth">
                      <a class="btn_selecionar" @click="selecionarClubeDesconto(item.id)">Ver Benefício</a>
                    </span>
                    <span v-else>
                      <a class="btn_selecionar" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Ver
                        Benefício</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <a class="btn_selecionar d-none" ref="modalSemPlano" id="btnModalSemPlano" data-bs-toggle="modal"
              data-bs-target="#exampleModalCenter">Ver
              Benefício</a>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              <strong> Clube de desconto </strong>
            </h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <span>
                Você não possui um plano contratado, não fique de fora assine
                agora mesmo um dos nossos planos e tenha acesso aos descontos.
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" style="background-color: var(--cor-principal)" data-bs-dismiss="modal"
              @click="$router.push('/')">
              Assinar agora
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalProblema" tabindex="-1" role="dialog" aria-labelledby="modalProblemaTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalProblemaTitle">
              <strong>Fale conosco</strong>
            </h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12 col-12 field">
              <label for="problema.tipo">Tipo</label>
              <select id="problema.tipo" required v-model="problema.tipo">
                <option value="cadastro">Cadastro: Dúvidas sobre alterar senha, alterar e-mail e cadastro bloqueado.
                </option>
                <option value="indicacao">Indique um parceiro: Caso queira indicar uma parceria ou oferecer um benefício.
                </option>
                <option value="problema"> Problema com desconto: Dúvidas sobre cupom de desconto, mecânica da oferta ou
                  condições do benefício.</option>
                <option value="duvida">Dúvidas e sugestões: Dúvidas sobre o Clube de benefícios ou sugestões de melhorias.
                </option>
              </select>
            </div>
            <div>
              <form @submit.prevent="enviarProblema" class="row my-0 px-0 px-lg-4 py-0">
                <div class="form-group col col-6">
                  <label for="problema.nome">Nome</label>
                  <input type="text" class="form-control" v-model="problema.nome" required />
                </div>
                <div class="form-group col col-6" v-if="problema.tipo === 'cadastro'">
                  <label for="problema.cpf">CPF</label>
                  <input type="text" class="form-control" v-model="problema.cpf" required />
                </div>
                <div class="form-group col col-6" v-if="problema.tipo === 'indicacao'">
                  <label for="problema.cpf">Empresa</label>
                  <input type="text" class="form-control" v-model="problema.empresa" required />
                </div>
                <div class="form-group col col-6" v-if="problema.tipo === 'problema'">
                  <label for="problema.cpf">Nome Parceiro</label>
                  <input type="text" class="form-control" v-model="problema.nomeParceiro" required />
                </div>
                <div class="form-group col col-6" v-if="problema.tipo === 'problema'">
                  <label for="problema.cpf">Link Produto</label>
                  <input type="text" class="form-control" v-model="problema.linkProduto" required />
                </div>
                <div class="form-group col col-6">
                  <label for="problema.email">E-mail</label>
                  <input type="text" class="form-control" v-model="problema.email" />
                </div>
                <div class="form-group col col-6">
                  <label for="problema.telefone">Telefone</label>
                  <input type="text" class="form-control" v-model="problema.telefone" required />
                </div>
                <div class="form-group col col-12">
                  <label for="problema.mensagem">Mensagem</label>
                  <textarea type="text" class="form-control" v-model="problema.mensagem" required></textarea>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-secondary" data-bs-dismiss="modal">
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { APIService } from "../APIService";
const apiService = new APIService();

export default {
  name: "DetalhesClubeDesconto",
  components: { Loading },
  data() {
    return {
      erro: "",
      loading: false,
      categoria: "",
      uf: "",
      pesquisa: "",
      search: "",
      descontos: [],
      categorias: [],
      clubeDesconto: {},
      problema: {
        tipo: "",
        nome: "",
        cpf: "",
        email: "",
        telefone: "",
        mensagem: "",
        empresa: "",
        nomeParceiro: "",
        linkProduto: "",
      },
      showCarousel: true,
      listaCarrosel: []
    };
  },
  created() {
    this.pesquisarDescontos();
    this.carregarCategorias();
    this.obterClubeBeneficio(this.$route.params.idDetalhe);
    window.addEventListener('resize', this.refreshCarousel)
    this.listaCarrosel = window.BANNER_CLUBE;
    this.$router.replace({
      query: {},
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.refreshCarousel)
  },
  methods: {
    carregarCategorias() {
      this.loading = true;
      apiService
        .obeterCatgoriaDescontos()
        .then((res) => {
          this.categorias = res;
        })
        .catch((error) => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    urlImage(imagemUrl) {
      return `url('${imagemUrl ||
        "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png"
        }')`;
    },
    openBeneficio(url) {
      if (url) {
        window.open(url, "_self")
      } else {
        console.error("URL não configurada");
      }
    },
    pesquisarDescontos() {
      this.loading = true;
      apiService
        .pesquisarDescontos(this.categoria, this.uf, this.search)
        .then((res) => {
          this.descontos = this.ordenarAleatoriamente(res).slice(0, 6);

          this.loading = false;
        })
        .catch((error) => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    obterClubeBeneficio(clubeDescontoId) {
      this.loading = true;
      var accessToken = this.$route.query.accessToken ? this.$route.query.accessToken : null;

      apiService
        .obterClubeBeneficio(clubeDescontoId, accessToken)
        .then((res) => {
          this.clubeDesconto = res;
        })
        .catch((error) => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        })
        .finally(() => (this.loading = false));
    },
    selecionarClubeDesconto(clubeDescontoId) {
      let token = localStorage.getItem("accessToken");
      this.$router.replace({
        params: { idDetalhe: clubeDescontoId },
        query: { accessToken: token },
      });
      window.location.reload();
    },
    ordenarAleatoriamente(lista) {
      lista.sort(() => Math.random() - 0.5);
      return lista;
    },
    enviarProblema() {
      console.log('Não implementado')
    },
    clickBanner(slide) {
      if (slide.href) {
        if (slide.idClube) {
          var clube = this.descontos.filter(o => o.linkAuth);
          if (clube && clube.length > 0) {
            const tokens = clube[0].linkAuth.split('accessToken=');

            if (tokens && tokens.length > 0) {
              window.open('#/servico/clube-desconto/' + slide.idClube + "?accessToken=" + tokens[1], '_blank')
            }
          } else {
            this.abrirModalSemPlano();
          }
        } else {
          if (!slide.href.includes("http")) {
            slide.href && this.$router.push(`/${slide.href}`)
            slide.url && window.open(slide.url, '_blank')
          } else {
            window.open(slide.href, '_blank')
          }
        }
      }
    },
    refreshCarousel() {
      this.showCarousel = false
      setTimeout(() => (this.showCarousel = true), 100)
    },
    abrirModalSemPlano() {
      document.getElementById("btnModalSemPlano").click();
    }
  },
};
</script>
<style scoped lang="scss">
.circle-categoria {
  background-color: var(--cor-secundaria);
  max-width: 65px;
}

.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-principal);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}

.chamada_categoria {
  max-height: 100px;
}

.chamada_categoria h3 {
  font-weight: 400;
  margin-top: 0.2rem;
  font-size: 2em;
}

.chamada_categoria p {
  font-size: 1.2rem;
  padding: 0 1rem;
}

.chamada_categoria.cat_familia h3 {
  color: var(--cor-principal);
  font-size: 1.3rem;
  margin: 0 8px;
}

.chamada_categoria.cat_familia hr {
  border: 0;
  display: flex;
  flex: 1;
  background: var(--cor-secundaria);
  height: 2px;
  position: relative;
}

.chamada_categoria.cat_familia hr:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: #01010100;
  background: -webkit-linear-gradient(left, #01010100, #ffffff);
  background: -moz-linear-gradient(left, #01010100, #ffffff);
  background: linear-gradient(to right, #01010100, #ffffff);
  width: 100%;
  height: 100%;
}

.chamada_categoria.cat_atleta h3 {
  color: #1d4f91;
}

.caixa_produtos {
  margin-bottom: 1rem;
}

.imgCategoria {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 300px;
}

.item_produto {
  cursor: pointer;
}

.item_produto .disabled {
  display: none !important;
  background: #cacaca;
  border-color: #cacaca;
}

.item_produto .tagEsgotado {
  background-color: var(--cor-secundaria);
  color: #fff;
  padding: 4px 32px;
  border-radius: 50px 0 0 50px;
  margin: 0 16px;
  position: absolute;
  z-index: 1;
  right: 0;
  display: none;
}

.item_produto.esgotado .tagEsgotado {
  display: initial;
}

.item_produto.esgotado .disabled {
  display: block !important;
}

.item_produto.esgotado .btn_selecionar:not(.disabled) {
  display: none !important;
}

.item_produto .btn_selecionar {
  font-size: x-small;
}

.item_produto.esgotado .valor *,
.item_produto.esgotado span {
  color: #cacaca !important;
}

.item_produto.esgotado .titulo_categoria {
  filter: opacity(0.3);
}

.lista_produtos .item_produto .titulo_categoria {
  font-weight: 400;
  font-size: 18px;
}
</style>
